module.exports = __webpack_public_path__ + "img/maid-cleaning-icon.50bd8903.svg";